"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        return React.createElement("div", { style: { width: '100%' } },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-sm-12 ", style: { backgroundColor: "#165c7d", padding: "10px" } },
                    React.createElement("a", { href: "https://www.floir.com", target: "_blank", rel: "noopener noreferrer" },
                        React.createElement("img", { className: "img-responsive center-block", style: { width: "250px" }, src: require('../images/oir-full-logo-white.png'), alt: "floir Logo" })),
                    React.createElement("div", { style: { color: "#fff", float: "right", fontWeight: "bold" } }, "CHOICES: Medicare Supplement Sample Rate Search"))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-sm-1" }),
                React.createElement("div", { id: "container", className: "col-sm-10 text-center", style: { width: '100%', padding: "10px" } },
                    React.createElement("div", { className: "block" },
                        React.createElement("a", { className: "navButton", href: "./" }, "Home")),
                    React.createElement("div", { className: "block" },
                        React.createElement("a", { className: "navButton", href: "CWSSearch" }, "Search")),
                    React.createElement("div", { className: "block" },
                        React.createElement("a", { className: "navButton", href: "https://floir.com/docs-sf/default-source/floir-documents/medigap-faqs.pdf", target: "_blank", rel: "noopener noreferrer" }, "FAQ")),
                    React.createElement("div", { className: "block" },
                        React.createElement("a", { className: "navButton", href: "https://www.medicare.gov/publications/11575-Getting-Started-Medicare-Supplement-Insurance.pdf", target: "_blank", rel: "noopener noreferrer" }, "Consumer Guide")),
                    React.createElement("div", { className: "block" },
                        React.createElement("a", { className: "navButton", href: "http://www.floir.com/Office/ContactUs.aspx", target: "_blank", rel: "noopener noreferrer" }, "Contact Us"))),
                React.createElement("div", { className: "col-sm-1" })));
    };
    return Header;
}(React.PureComponent));
;
exports.default = Header;
//# sourceMappingURL=Header.js.map